// extracted by mini-css-extract-plugin
export default {"speakerColorPicker":"speakerColorPicker__jxTC2B","circleButton":"circleButton__mE1Wvm"};